export default __webpack_public_path__ + "b1375cbcd5d43d5ccf368ec8df4a0c7c.svg";